var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.46875 1.3559L14.0937 6.9809L8.46875 12.6059M13.3125 6.9809L1.90625 6.98089","stroke":"currentColor","stroke-width":"1.875","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }